import React, {useState, useEffect} from "react";
import {
    Typography,
    Grid,
    TextField as RTextField,
    Box,
    Button,
    makeStyles,
    Container,
} from "@material-ui/core";
import {TextField} from "formik-material-ui";
import MuiPhoneNumber from "material-ui-phone-number";
import {Formik, Form, Field, ErrorMessage} from "formik";
import {colorError,} from "../../../constants/theme";
import * as Yup from "yup";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import moment from "moment";
import { useSnackbar } from "notistack";
import {createUserProfile, getUserProfile, patchUserProfile} from "../../../redux/userProfile/userProfile.actions";
import Autocomplete from "@mui/lab/Autocomplete";
import {specialities} from "../../../constants/specialities";

interface Props {
	changeCount: (number: number) => void;
	getLocation: () => void;
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    cancelButton: {
        border: `1.5px solid ${colorError}`,
        color: colorError
    },
    hidden: {
        display: "none"
    },
    formError: {
        color: colorError,
        fontSize: "12px",
        marginLeft: "14px",
        marginTop: "4px"
    },
    applyBtn: {
        height: 56
    },
}));

interface IProfile {
	firstName: string,
	lastName: string,
	phoneNumber: string,
	practiceCode: string,
    speciality: [],
	userId: number,
	type: string,
	locationTimeZone: string,
	usState?: string,
	birthday?: string,
    findUs: string,
    education: string
}

const Profile = ({changeCount}: Props) => {
    const classes = useStyle();
    const { enqueueSnackbar } = useSnackbar();
    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        phoneNumber: Yup.string().length(14, "Invalid Phone Number").required("Required"),
        speciality: Yup.array().min(1, "Required").required("Required"),
    });
    const user = JSON.parse(localStorage.getItem("auth"));
    const dispatch = useAppDispatch();
    const today = moment();
    const [formikValues, setFormikValues] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        speciality: [],
        education: "",
        summary: "",
    });
    const [profileId, setProfileId] = useState(0);
    const [isSubmit, setIsSubmit] = useState(false);
    const [isPhone, setIsPhone] = useState(false);
    const [isSpeciality, setSpeciality] = useState(false);

    useEffect(() => {
        dispatch(getUserProfile({userId: user.userId})).then((profile) => {
            // Presetting fields with data from BE
            if (profile.length) {
                setProfileId(profile[0].id);
                const newFormikValues = {...formikValues};
                newFormikValues.firstName = profile[0]?.firstName || "";
                newFormikValues.lastName = profile[0].lastName || "";
                newFormikValues.phoneNumber = profile[0].phoneNumber || "";
                newFormikValues.speciality = profile[0]?.speciality?.map(el => specialities.find(item => item.value === el)) || [];
                newFormikValues.education = profile[0]?.education || "";
                newFormikValues.summary = profile[0].summary || "";
                setFormikValues({...newFormikValues});
            }
        });
    },[]);

    return (
        <Container className={classes.body} disableGutters={true}>
            <Typography variant="h2" gutterBottom>
                Your Profile
            </Typography>
            <Formik
                initialValues={formikValues}
                enableReinitialize
                onSubmit={async (values: any) => {
                    try {
                        // setBirthdayValidationFailed(!birthday);
                        // if (!birthday) return;
                        const userId = user.userId;
                        const type = "vet";
                        let body: IProfile = {
                            firstName: values.firstName,
                            lastName: values.lastName,
                            phoneNumber: values.phoneNumber,
                            speciality: values.speciality.map(el => el.value),
                            userId,
                            type,
                            education: values.education
                        };
                        if(profileId !== 0){
                            await dispatch(patchUserProfile({id: profileId, body: body}));
                        } else {
                            await dispatch(createUserProfile(body));
                        }
                        changeCount(1);
                    } catch (error) {
                        enqueueSnackbar(error.errorMessage, {
                            variant: "error",
                            autoHideDuration: 3000,
                        });
                    }
                }}
                validationSchema={validationSchema}
            >
                {({isSubmitting, errors, values, handleChange, setFieldValue, enableReinitialize=true}) => (
                    <Form>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="body2">
                                    First Name
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Field
                                    id="firstName"
                                    label="First Name"
                                    name="firstName"
                                    component={TextField}
                                    variant="outlined"
                                    type="text"
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    onChange={handleChange}
                                    value={values.firstName}
                                    placeholder=""
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2">
                                    Last Name
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <Field
                                    id="lastName"
                                    name="lastName"
                                    label="Last Name"
                                    component={TextField}
                                    variant="outlined"
                                    type="text"
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    onChange={handleChange}
                                    value={values.lastName}
                                    placeholder=""
                                />
                            </Grid>
                        </Grid>
                        <Grid container className={classes.spacing}>
                            <Grid item xs={12}>
                                <Typography variant="body2" gutterBottom>
                                    Phone Number
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography gutterBottom>
									We recommend using a cell phone number so that you can receive SMS appointment reminders and follow up check ins!
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <MuiPhoneNumber
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    defaultCountry={"us"}
                                    onlyCountries={["us"]}
                                    error={(isSubmit || isPhone) && values.phoneNumber.length !== 14}
                                    onChange={(value) => {
                                        setFieldValue("phoneNumber", value);
                                        setIsPhone(false);
                                    }}
                                    onBlur={() => {
                                        if (!values.phoneNumber.length) {
                                            setFieldValue("phoneNumber", "");
                                            setIsPhone(true);
                                        }
                                    }}
                                    value={values.phoneNumber}
                                    disableCountryCode={true}
                                    variant="outlined"
                                    fullWidth
                                />
                                {(values.phoneNumber.length !== 14 && (isSubmit || isPhone)) && <Typography
                                    className={classes.formError}>{values.phoneNumber.length !== 14 ? "Invalid Phone Number" : "Required"}</Typography>}
                            </Grid>
                            <Grid container style={{marginTop: 10, marginBottom: 10}}>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="body2"
                                    >
                                        Species Treated
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}  sm={9}>
                                    <Autocomplete
                                        multiple
                                        fullWidth={true}
                                        getOptionLabel={(option) => option.label}
                                        options={specialities}
                                        renderInput={(params) => <RTextField {...params} variant="outlined" />}
                                        value={specialities.filter(type => values.speciality.find(el => el?.value === type?.value)) || []}
                                        //@ts-ignore
                                        onChange={(event, value) => {
                                           setFieldValue("speciality", value);
                                            setSpeciality(false);
                                        }}
                                        onBlur={() => {
                                            if (!values.speciality.length) {
                                                setFieldValue("speciality", []);
                                                setSpeciality(true);
                                            }
                                        }}
                                    />
                                    <ErrorMessage name="speciality">
                                        {msg => <Typography className={classes.formError}>{msg}</Typography>}
                                    </ErrorMessage>
                                </Grid>
                            </Grid>
                            <Typography
                                variant="body2"
                                style={{marginTop: 10, marginBottom: 10}}
                            >
                                Education
                            </Typography>
                            <Grid item container alignItems="center" xs={12}>
                                <Field
                                    component={TextField}
                                    variant="outlined"
                                    name="education"
                                    fullWidth
                                    size="medium"
                                    placeholder="Where did you receive your education from?"
                                    onChange={handleChange("education")}
                                    value={values.education}
                                />
                            </Grid>
                            <Typography variant="body2"  style={{marginTop: 10, marginBottom: 10}}>Bio</Typography>
                            <Grid container >
                                <Grid item container justify="center" xs={12}>
                                    <Field
                                        component={TextField}
                                        variant="outlined"
                                        multiline
                                        rows={5}
                                        fullWidth
                                        name="summary"
                                        onChange={handleChange("summary")}
                                        value={values.summary}
                                        placeholder="Couple of words about yourself"
                                    />
                                </Grid>
                            </Grid>
                            {/*<Grid item xs={12}>*/}
                            {/*    <Typography variant="body2">*/}
                            {/*        Practice Code*/}
                            {/*    </Typography>*/}
                            {/*</Grid>*/}
                            {/*<Grid item xs={12} sm={9}>*/}
                            {/*    <Field*/}
                            {/*        id="practiceCode"*/}
                            {/*        name="practiceCode"*/}
                            {/*        label="Practice Code"*/}
                            {/*        component={TextField}*/}
                            {/*        variant="outlined"*/}
                            {/*        color="secondary"*/}
                            {/*        type="text"*/}
                            {/*        margin="dense"*/}
                            {/*        size="small"*/}
                            {/*        fullWidth*/}
                            {/*        onChange={handleChange}*/}
                            {/*        value={values.practiceCode}*/}
                            {/*        placeholder=""*/}
                            {/*    />*/}
                            {/*</Grid>*/}
                        </Grid>
                        <Grid container justify="flex-start" spacing={2} className={classes.spacing}>
                            <Grid item xs={12} sm={3}>
                                <Button
                                    fullWidth
                                    color="secondary"
                                    variant="outlined"
                                    type="submit"
                                    data-testid="submitButton"
                                    onClick={()=> setIsSubmit(true)}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Container>
    );
};

export default Profile;
